module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-exclamation-f5c058cb2da9e3919f7960334cda23ab.svg";